import { newsList as rawNews } from "@/mocks/news";

export type NewsCategory = "电影新闻" | "电视剧新闻" | "行业动态";

export interface NewsItem {
  id: string;
  title: string;
  category: NewsCategory;
  publishTime: string;
  author: string;
  summary: string;
  image: string;
  relatedMediaId: string;
  content: string[];
}

export const newsList = rawNews as NewsItem[];

export const NEWS_CATEGORIES: NewsCategory[] = ["电影新闻", "电视剧新闻", "行业动态"];

export const NEWS_PAGE_SIZE = 6;

export function sortNewsByTime(items: NewsItem[]): NewsItem[] {
  return [...items].sort((a, b) => b.publishTime.localeCompare(a.publishTime));
}

export function getNewsById(id: string | undefined): NewsItem | undefined {
  if (!id) return undefined;
  return newsList.find((item) => item.id === id);
}

export function getNewsByCategory(category: string): NewsItem[] {
  if (!category || category === "全部") return sortNewsByTime(newsList);
  return sortNewsByTime(newsList.filter((item) => item.category === category));
}

export function getNewsByMedia(mediaId: string): NewsItem[] {
  return sortNewsByTime(newsList.filter((item) => item.relatedMediaId === mediaId));
}

export function getRelatedNews(item: NewsItem | undefined, limit = 4): NewsItem[] {
  if (!item) return sortNewsByTime(newsList).slice(0, limit);
  const sameCategory = sortNewsByTime(newsList).filter(
    (n) => n.id !== item.id && n.category === item.category
  );
  const others = sortNewsByTime(newsList).filter(
    (n) => n.id !== item.id && n.category !== item.category
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function searchNews(keyword: string): NewsItem[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return sortNewsByTime(newsList).filter((item) => {
    const haystack = [item.title, item.summary, item.category, item.author, item.content.join(" ")]
      .join(" ")
      .toLowerCase();
    return haystack.includes(key);
  });
}

export function paginateNews(items: NewsItem[], page: number, pageSize = NEWS_PAGE_SIZE): NewsItem[] {
  const start = (page - 1) * pageSize;
  return items.slice(start, start + pageSize);
}